import { Controller } from '@hotwired/stimulus';
import Splide from '@splidejs/splide';

export default class extends Controller {
    connect() {

        const context = this;
        const element = context.element;
        const additionalConfig = element.dataset.splide ? JSON.parse(element.dataset.splide) : {}

        // Config https://splidejs.com/guides/options/
        const config = {
            lazyLoad: 'nearby',
            autoWidth: true,
            focus: 'left',
            speed: 1000,
            autoplay: true,
            ...additionalConfig,
        };

        context.splide = new Splide(element, config)
        context.splide.mount()

        if (element.dataset.gallery === "true") {

            context.thumbSplide = new Splide(element.querySelector(".thumbnails"), {
                lazyLoad: 'nearby',
                autoWidth: true,
                focus: 'left',
                speed: 1000,
                autoplay: false,
                gap: '5px',
                pagination: false,
                arrows: false,
            })
            context.thumbSplide.mount()

            context.thumbnails(0);
            context.splide.on( 'active', function (activeSlide) {
                context.thumbnails(activeSlide.index);
            });
        }
    }

    thumbnails(index) {

        const context = this;
        context.thumbSplide.go(index)
        context.thumbSplide.on( 'click', function (activeSlide) {
            context.splide.go(activeSlide.index)
        });
    }
}
